import React, { useState, useEffect } from "react";
import { CTAButton, Header, Styled } from "./styled";
import { FiSearch } from "react-icons/fi";
import { FaStar, FaEllipsisH } from "react-icons/fa";
import styled from "styled-components";
import AddMemberModal from "./AddMemberModal";
import {
  Table,
  Avatar,
  Tag,
  Space,
  Tooltip,
  Dropdown,
  Menu,
  Button,
  Col,
  message,
  Modal,
  Input
} from "antd";
import { StyledTable } from "../../../admin/videos/styled";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { groupService } from "../../../../../services/Group";
import moment from "moment";
import { notify } from "../../../../../utils/helper";
import DeleteConfirmationModal from "../../../physician_page/component/DeleteConfirmationModal";
import { CustomSearchContainer } from "../../../../table-item";


const Members = () => {
  const [search, setSearch] = useState("");
  const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [removingMember, setRemovingMember] = useState(null);
  const [removingGroupId, setRemovingGroupId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const fetchMembers = async (
    searchTerm = "",
    page = 1,
    pageSize = 25
  ) => {
    setLoading(true);
    try {
      const response = await groupService.getGroupMembers(
        searchTerm,
        page,
        pageSize
      );
      // console.log("members", response);
      setMembers(response?.data?.results || []);
      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize,
        total: response?.data?.totalResults || 0,
      }));
    } catch (error) {
      setMembers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers(search, pagination.current, pagination.pageSize);
    // eslint-disable-next-line
  }, [search]);

  const handleTableChange = (paginationObj) => {
    fetchMembers(search, paginationObj.current, paginationObj.pageSize);
  };

  const handlePageSizeChange = (current, size) => {
    setPagination((prev) => ({ ...prev, current, pageSize: size }));
    fetchMembers(search, current, size);
  };

  const handleAddMemberSuccess = () => {
    fetchMembers(search, pagination.current, pagination.pageSize);
  };

  const handleViewDetails = (memberId) => {
    // console.log("View details for member:", memberId);
    // Add your view details logic here
  };

  const handleEditMember = (memberId) => {
    // console.log("Edit member:", memberId);
    // Add your edit member logic here
  };

  const handleRemoveFromGroup = (memberId, groupId) => {
    setRemovingMember(memberId);
    setRemovingGroupId(groupId);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmRemove = async () => {
    setDeleteLoading(true);
    try {
      await groupService.removeMembersFromGroup({
        groupId: removingGroupId,
        memberIds: [removingMember],
      });
      notify("success", "Member removed from group successfully");
      fetchMembers(search, pagination.current, pagination.pageSize);
      setIsDeleteModalOpen(false);
    } catch (error) {
      notify("error", "Failed to remove member from group");
    } finally {
      setDeleteLoading(false);
      setRemovingMember(null);
      setRemovingGroupId(null);
    }
  };

  const memberColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 250,
      render: (name, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Avatar
            size={40}
            style={{
              backgroundColor: "var(--border-color)",
              color: "var(--primary-text-color)",
            }}
          >
            {name?.charAt(0)}
          </Avatar>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <strong>{name}</strong>
            <div className="email">{record.email}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Group",
      key: "group",
      width: 200,
      render: (_, record) => record.company?.hospitalName || "—",
    },

    {
      title: "Videos",
      key: "videos",
      width: 100,
      align: "center",
      render: (_, record) => record.videoCount ?? 0,
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      width: 120,
      align: "center",
      render: (role) => (
        <Tag
          color={role === "Admin" ? "purple" : "default"}
          style={{
            borderRadius: "12px",
            padding: "4px 10px",
            fontSize: "0.8rem",
            fontWeight: "500",
          }}
        >
          {role}
        </Tag>
      ),
    },
    {
      title: "Created At",
      key: "createdAt",
      width: 120,
      align: "center",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (_, record) =>
        record.createdAt
          ? moment(record.createdAt).format("DD MMM YYYY hh:mm A")
          : "N/A",
    },
    {
      title: "Actions",
      key: "actions",
      width: 80,
      align: "center",
      render: (_, record, index) => {
        const menu = (
          <Menu>
            {/* <Menu.Item
              key="view"
              icon={<EyeOutlined />}
              onClick={() => handleViewDetails(record.id || record._id)}
            >
              View Details
            </Menu.Item>
            <Menu.Item
              key="edit"
              icon={<EditOutlined />}
              onClick={() => handleEditMember(record.id || record._id)}
            >
              Edit Member
            </Menu.Item> */}
            <Menu.Item
              key="remove"
              icon={<DeleteOutlined />}
              danger
              onClick={() => handleRemoveFromGroup(record.id || record._id, record.company?._id)}
            >
              Remove from Group
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown
            overlay={menu}
            trigger={["click"]}
            placement="bottomRight"
            onOpenChange={(visible) => {
              if (visible) {
                setSelectedMemberId(record.id || record._id);
              }
            }}
          >
            <Tooltip title="More actions">
              <FaEllipsisH
                style={{
                  cursor: "pointer",
                  color: "var(--secondary-text-color)",
                  padding: "4px",
                  fontSize: "25px",
                }}
              />
            </Tooltip>
          </Dropdown>
        );
      },
    },
  ];

  const hasData = members.length > 0;
  const scroll = hasData ? { y: `calc(100vh - 320px)`, x: true } : { x: true };

  return (
    <Styled>
      <Header>
        <div className="row1">
          <div className="heading_text">Group Members</div>
          <CTAButton onClick={() => setIsAddMemberModalOpen(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-plus mr-2 h-4 w-4"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5v14"></path>
            </svg>{" "}
            Add Member
          </CTAButton>
        </div>
      </Header>

      <CustomSearchContainer style={{ marginTop: "15px" }}>
        <FiSearch
         style={{ position: "absolute", zIndex: 1 }}
         className="icon ml-5" />
        <Input
          type="text"
          placeholder="Search members..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </CustomSearchContainer>

      <Col span={24} style={{ flex: 1, padding: "0px", marginTop: "15px" }}>
        <StyledTable
          columns={memberColumns}
          dataSource={members}
          loading={loading}
          rowKey={(record) => record.id || record._id}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true,
            pageSizeOptions: [25, 50, 100],
            onShowSizeChange: handlePageSizeChange,
            total: pagination.total,
            showTotal: (total, range) =>
              `${range[0]} - ${range[1]} of ${total} members`,
            showQuickJumper: false,
            showLessItems: true,
            onChange: (page, pageSize) => {
              setPagination((prev) => ({ ...prev, current: page, pageSize }));
              fetchMembers(search, page, pageSize);
            },
            itemRender: (page, type, originalElement) => {
              if (type === "prev") {
                return (
                  <Button
                    type="text"
                    disabled={pagination.current === 1}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (pagination.current > 1) {
                        setPagination((prev) => ({
                          ...prev,
                          current: prev.current - 1,
                        }));
                        fetchMembers(
                          search,
                          pagination.current - 1,
                          pagination.pageSize
                        );
                      }
                    }}
                  >
                    Previous
                  </Button>
                );
              }
              if (type === "next") {
                const maxPage = Math.ceil(
                  pagination.total / pagination.pageSize
                );
                return (
                  <Button
                    type="text"
                    disabled={pagination.current === maxPage}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (pagination.current < maxPage) {
                        setPagination((prev) => ({
                          ...prev,
                          current: prev.current + 1,
                        }));
                        fetchMembers(
                          search,
                          pagination.current + 1,
                          pagination.pageSize
                        );
                      }
                    }}
                  >
                    Next
                  </Button>
                );
              }
              return originalElement;
            },
          }}
          scroll={scroll}
          onChange={handleTableChange}
        />
      </Col>

      {isAddMemberModalOpen && (
        <AddMemberModal
          isOpen={isAddMemberModalOpen}
          setIsOpen={setIsAddMemberModalOpen}
          onSuccess={handleAddMemberSuccess}
        />
      )}
      {isDeleteModalOpen && (
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          setOpen={setIsDeleteModalOpen}
          onConfiem={handleConfirmRemove}
          loading={deleteLoading}
          title={"Remove Member"}
          message={"Are you sure you want to remove this member from the group?"}
        />
      )}
    </Styled>
  );
};

export default Members;

const SearchBar = styled.div`
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 20px;

  input {
    border: none;
    outline: none;
    width: 100%;
    background-color: inherit;
    color: var(--secondary-text-color);
  }
`;
